module.exports = __webpack_public_path__ + "media/images/ibu__icon__user-47fbed60f7b0618a9f5ae9334a74b996.svg";